import * as z from "zod";

export const getGoogleMapsKey = {
  name: "getGoogleMapsKey" as const,
  input: z.object({}),
  output: z.object({ apiKey: z.string() }),
};
